/**
 *
 * @param element -  An HTML element
 * @return `number` - A non-negative number is returned if the element passed in was defined, or a -1 if the element passed in was null or there was an error in deriving the text line count
 *
 * A helper function to determine how many text line an element is made up of. The function takes that element's height, and divides it by the line-height value.
 * This derives the amount of lines of text that an element may have.
 */
export function getHTMLElementLineCount(element) {
    var _a;
    if (element) {
        const elementHeight = element === null || element === void 0 ? void 0 : element.offsetHeight;
        let elementLineHeight;
        try {
            elementLineHeight = ((_a = element === null || element === void 0 ? void 0 : element.style) === null || _a === void 0 ? void 0 : _a.lineHeight)
                ? parseInt(element.style.lineHeight, 10)
                : parseInt(getHTMLElementCSSProperty(element, 'line-height'), 10);
            // Round up the text line count, in case the value is derived as decimal
            return Math.ceil(elementHeight / elementLineHeight);
        }
        catch (e) {
            console.warn("Failed to derive an element's text line count: ", e);
            return -1;
        }
    }
    // In case the element was not defined.
    return -1;
}
export function getHTMLElementCSSProperty(element, cssProperty) {
    var _a;
    if (element && cssProperty) {
        try {
            return (_a = document.defaultView.getComputedStyle(element, null)) === null || _a === void 0 ? void 0 : _a.getPropertyValue(cssProperty);
        }
        catch (_b) {
            console.warn(`An error occurred when trying to extract the cssProperty ${cssProperty} from an HTMLElement.`);
            return '';
        }
    }
    return '';
}
/** Derives whether or not an element is visible in the DOM. This means that if one of the parent elements has a display: 'none' property,
 *  then the child element is considered not visible in the DOM and on the user's screen. */
export function getHTMLElementVisibility(element) {
    return !!((element === null || element === void 0 ? void 0 : element.offsetWidth) || (element === null || element === void 0 ? void 0 : element.offsetHeight) || (element === null || element === void 0 ? void 0 : element.getClientRects().length));
}
